<template>
  <BlokkliProvider v-if="node" tag="main" v-bind="node.blokkliProps">
    <div class="border-b border-b-gray-200 mb-40">
      <ContentHeader :title="node.title" />
    </div>

    <Container class="mb-80">
      <TopicOverview />
    </Container>

    <BlokkliField name="field_paragraphs" :list="node.paragraphs" />
  </BlokkliProvider>
</template>

<script lang="ts" setup>
definePageMeta({
  name: 'topics-overview',
  drupalFrontendRoute: true,
  languageMapping: {
    de: '/themen',
    fr: '/fr/sujets',
    en: '/en/topics',
    it: '/it/temi',
    ls: '/ls/themen',
  },
})

const { entity: node } = await useDrupalRouteQuery('page', {
  menuKey: 'topics',
})
await renderPageDependencies()
</script>
